import { ThemeColors } from './theme.types';

export const lightColors: ThemeColors = {
  // Base
  background: '#FAFAFA',
  backgroundSecondary: '#F5F5F5',
  surface: '#FFFFFF',
  surfaceHover: '#F5F5F5',

  // Text
  text: '#171717',
  textSecondary: '#525252',
  textTertiary: '#737373',
  textMuted: '#888888',
  textInverse: '#FFFFFF',

  // Primary
  primary: '#4F46E5',
  primaryHover: '#4338CA',
  primaryActive: '#3730A3',

  // Borders
  border: '#E5E5E5',
  borderLight: '#F5F5F5',

  // Semantic
  success: '#10B981',
  successBg: 'rgba(16, 185, 129, 0.1)',
  warning: '#F59E0B',
  warningBg: 'rgba(245, 158, 11, 0.1)',
  error: '#EF4444',
  errorBg: 'rgba(239, 68, 68, 0.1)',
  info: '#3B82F6',
  infoBg: 'rgba(59, 130, 246, 0.1)',

  // Overlays
  overlay: 'rgba(0, 0, 0, 0.5)',
  overlayLight: 'rgba(0, 0, 0, 0.1)',
};

export const darkColors: ThemeColors = {
  // Base
  background: '#0d0d0d',
  backgroundSecondary: '#141414',
  surface: '#1c1c1c',
  surfaceHover: '#242424',

  // Text
  text: '#E8E8E8',
  textSecondary: '#8A8A8A',
  textTertiary: '#606060',
  textMuted: '#505050',
  textInverse: '#141414',

  // Primary
  primary: '#818cf8',
  primaryHover: '#a5b4fc',
  primaryActive: '#6366f1',

  // Borders
  border: '#2e2e2e',
  borderLight: 'transparent',

  // Semantic
  success: '#34D399',
  successBg: 'rgba(52, 211, 153, 0.15)',
  warning: '#FBBF24',
  warningBg: 'rgba(251, 191, 36, 0.15)',
  error: '#F87171',
  errorBg: 'rgba(248, 113, 113, 0.15)',
  info: '#60A5FA',
  infoBg: 'rgba(96, 165, 250, 0.15)',

  // Overlays
  overlay: 'rgba(0, 0, 0, 0.7)',
  overlayLight: 'rgba(255, 255, 255, 0.1)',
};
